<template>
  <div v-if="$store.state.magazine.magazineFalg">
    <div class="modal-backdrop fade in" style="z-index: 1040;"></div>
    <div
      class="modal fade ng-isolate-scope in"
      animate="animate"
      style="z-index: 1050; display: block;"
      @click.stop="cancel"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="inmodal">
            <div class="modal-content animated fadeIn">
              <div class="modal-header">
                <button type="button" class="close" @click.stop="cancel">
                  <span aria-hidden="true">&times;</span>
                  <span class="sr-only">Close</span>
                </button>
              </div>
              <div class="modal-body" style="height:750px;">
                <div class="col-sm-12" style="height: 700px;max-width: 450px;min-width: 320px;">
                    <iframe id="landingPage" :src="magazineUrl"  width="100%" height="700px"></iframe>
                </div>
              </div>
              <div class="modal-footer" id="warnBtnWrap">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../../config";
export default {
  mixins: [config.globalMixin],
  name: "magazineDlgController",
  props:['rnd'],
  data() {
    return {
      magazineUrl:""
    };
  },
  methods: {
    cancel: function() {
      this.$store.commit("setmagazine", { string: "", boolean: false });
    }
  },
  mounted: function() {},
  watch: {
    rnd: function() {
      var rnd = Date.now();
      this.magazineUrl = "";
      var that = this;
      setTimeout(function(){
        that.magazineUrl = process.env.VUE_APP_API_WEBDOMAIN + '/onlineMagazineDetail/'+that.$store.state.magazine.id + "/preview?rnd="+rnd;
      },200)
    }
  }
};
</script>
